import { useCallback } from 'react';
import { View as RNView, StyleSheet, TouchableOpacity } from 'react-native';
import { useLayoutAnimation } from 'use-layout-animation';

const styles = StyleSheet.create({
  container: {
    alignSelf: 'stretch',
    justifyContent: 'center',
    flexDirection: 'row',
    padding: 8,
  },
  dotContainer: {
    width: 16,
    height: 16,
    alignItems: 'center',
    justifyContent: 'center',
  },
  dot: {
    width: 6,
    height: 6,
    borderRadius: 3,
  },
  activeDot: {
    transform: [{ scale: 1.5 }],
  },
  inactiveDot: {
    opacity: 0.5,
  },
});

interface Props {
  length: number;
  color: string;
  activeIndex: number;
  onPress?(index: number): void;
}

interface DotProps {
  color: string;
  index: number;
  active: boolean;
  onPress?(index: number): void;
}

function Dot({ active, index, color, onPress }: DotProps) {
  const handlePress = useCallback(() => onPress?.(index), [onPress, index]);
  return (
    <TouchableOpacity
      disabled={active || !onPress}
      style={styles.dotContainer}
      onPress={handlePress}
    >
      <RNView
        style={[
          styles.dot,
          active ? styles.activeDot : styles.inactiveDot,
          { backgroundColor: color },
        ]}
      />
    </TouchableOpacity>
  );
}

export function Pagination({ length, color, activeIndex, onPress }: Props) {
  useLayoutAnimation([activeIndex]);
  return (
    <RNView style={styles.container}>
      {Array(length)
        .fill(undefined)
        .map((_, index) => (
          <Dot
            key={index}
            index={index}
            color={color}
            active={index === activeIndex}
            onPress={onPress}
          />
        ))}
    </RNView>
  );
}
